export const payment = (
	interestPerPeriod: number,
	periods: number,
	presentValue: number,
) => {
	if (periods === 0) {
		return 0;
	}

	if (interestPerPeriod === 0) {
		return -presentValue / periods;
	}

	const factor = (1 + interestPerPeriod) ** periods;

	return (-interestPerPeriod * presentValue * factor) / (factor - 1);
};
